var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceDataBottomLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 545,
    height: 714,
    viewBox: "0 0 545 714",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M367.531 611.42L356.274 592.705L306.281 509.559L245.032 611.42H367.531Z",
    fill: "#00CC8F"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M545 531.15H448.473L448.466 531.159L496.726 611.42H496.74L545 531.159V531.15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 509.549L245.018 611.41H245.032L306.281 509.549L306.274 509.54H183.775L183.769 509.549Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M367.515 612.39L427.882 712.777H307.152L367.515 612.39Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2632 305.792L61.2563 305.801L122.506 407.662H122.519L183.769 305.801L183.762 305.792H61.2632Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 407.663L183.769 305.802L122.52 407.663H245.018Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 407.678L183.762 509.539H183.776L245.025 407.678L245.018 407.66H122.52L122.513 407.678Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M183.769 102.061L122.513 203.922H245.018L183.769 102.061Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M122.506 203.923H122.513L183.769 102.063L183.762 102.054H61.2563V102.063L122.506 203.923Z",
    fill: "white",
    fillOpacity: 0.3
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 0.191895L61.2563 102.053H183.762L122.513 0.191895Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.513 610.451L62.1352 510.04H182.89L122.513 610.451Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.506 407.671H0.00684357L0 407.68L61.2494 509.541H61.2631H183.762L122.513 407.68L122.506 407.671Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M182.878 305.294H61.5322L0.878781 204.424H122.224L182.878 305.294Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M306.268 713.277H306.275H306.268L245.025 611.417L183.776 713.277H306.254H306.268Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 203.923H245.025L306.281 102.063L306.274 102.054H183.769V102.063L245.018 203.923Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M428.794 510.521L489.159 610.912H368.428L385.071 583.222L385.071 583.222L428.794 510.521Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M384.214 582.705L367.623 610.309L367.614 610.287L367.523 610.438L356.702 592.437L356.332 592.66L356.702 592.437L306.866 509.55L367.538 408.649L428.21 509.55L384.214 582.704L384.638 582.96L384.214 582.705ZM366.638 611.91L306.268 712.309L245.904 611.91H366.638ZM183.769 510.519L244.441 611.42L183.493 712.78H62.1473L122.801 611.91H122.802L122.948 611.667L183.769 510.519Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 508.58L245.898 408.16H366.664L306.281 508.58Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M183.762 509.54L183.769 509.549L183.775 509.54H183.762Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.254 289.751L352.652 255.83L373.056 289.751H332.254Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M236.514 79.9321L269.052 25.8218L301.59 79.9321H236.514Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 102.054H306.274L306.281 102.062V102.054Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M490.05 611.421L490.057 611.412H490.043L490.05 611.421Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M428.801 509.54H428.787L428.794 509.549L428.801 509.54Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 102.054H183.762L183.768 102.062V102.054Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M367.544 407.66H367.531L367.538 407.677L367.544 407.66Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M184.647 306.292H305.402L245.025 406.703L184.647 306.292Z",
    stroke: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M244.134 204.424L183.762 304.824L123.391 204.424H244.134Z",
    stroke: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 203.924L183.762 305.794H306.302L245.018 203.924Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M183.742 713.286H183.755L244.998 611.443L244.991 611.425L244.998 611.417H122.499L122.492 611.425L183.742 713.286Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M306.281 713.286H306.302L367.537 611.443L367.531 611.425L367.537 611.417H245.045L245.039 611.425L306.281 713.286Z",
    fill: "white",
    fillOpacity: 0.14
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245.018 203.923L306.288 102.089L306.275 102.071L306.282 102.054H183.79L183.783 102.071L245.018 203.923Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    d: "M122.205 407.864H122.218L183.461 306.021L183.454 306.004L183.461 305.986H60.9619L60.9551 306.004L122.205 407.864Z",
    fill: "#00CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M428.766 509.532L417.509 490.817L367.517 407.671L306.268 509.532H428.766Z",
    fill: "#00CC8F"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.689 537.988L428.794 509.54H306.295L367.544 611.401L411.689 537.988Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M325.132 294.541L288.362 355.689V355.698H288.369H361.902L325.132 294.541Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 611.357L184.084 713.183H122.855V611.357Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceDataBottomLeft);
export default __webpack_public_path__ + "static/media/serviceDataBottomLeft.566ed31c691e9e3f2bdf95f7ead5d06f.svg";
export { ForwardRef as ReactComponent };